import { render, staticRenderFns } from "./VisualizarModelo.vue?vue&type=template&id=cca2b2ce"
import script from "./VisualizarModelo.vue?vue&type=script&lang=js"
export * from "./VisualizarModelo.vue?vue&type=script&lang=js"
import style0 from "./VisualizarModelo.vue?vue&type=style&index=0&id=cca2b2ce&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports